var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "col-xs-12 col-sm-12 p-0",
      class: [
        _vm.alignment == "left" && !_vm.colBlock ? "col-md-pull-6" : "",
        _vm.colBlock ? "" : "col-md-6",
      ],
    },
    [
      _vm.design_type == "desktop"
        ? _c("div", { staticClass: "desc-content" }, [
            _c("div", {
              staticClass: "desc-subheader text-color-blue",
              domProps: { innerHTML: _vm._s(_vm.content.header) },
            }),
            _c("div", {
              domProps: { innerHTML: _vm._s(_vm.content.description) },
            }),
          ])
        : _vm._e(),
      _vm.design_type == "default" || _vm.design_type == "screen"
        ? _c(
            "div",
            {
              staticClass: "row box-min-height p-35",
              class: [
                _vm.content.bg_color !== undefined &&
                _vm.content.bg_color == "white"
                  ? ""
                  : "bg-color-blue text-color-white",
              ],
            },
            [
              _c("div", { staticClass: "col-xs-12 col-sm-12 p-0" }, [
                _vm.content.img
                  ? _c("img", {
                      staticClass: "block-img",
                      attrs: {
                        src: `${_vm.getImageUrl(_vm.content.img)}`,
                        alt: "img",
                      },
                    })
                  : _vm._e(),
              ]),
              _vm.button_valid && _vm.colBlock
                ? _c("div", [
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn emergo-green-button side-btn float-btn",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("openRequest")
                          },
                        },
                      },
                      [_c("span", [_vm._v(_vm._s(_vm.button_name))])]
                    ),
                  ])
                : _vm._e(),
              _c("div", {
                staticClass: "desc-subheader col-xs-12 col-sm-12 p-0",
                class: [
                  _vm.content.bg_color !== undefined &&
                  _vm.content.bg_color == "white"
                    ? "text-color-blue"
                    : "",
                  _vm.colBlock
                    ? "desc-subheader col-xs-12 col-sm-12 col-md-10 p-0"
                    : "",
                ],
                domProps: { innerHTML: _vm._s(_vm.content.header) },
              }),
              _c(
                "div",
                {
                  staticClass: "col-xs-12 col-sm-12 p-0",
                  class: [_vm.colBlock ? "col-md-7" : ""],
                },
                [
                  _c("span", {
                    domProps: { innerHTML: _vm._s(_vm.content.description) },
                  }),
                ]
              ),
              _vm.button_valid && !_vm.colBlock
                ? _c(
                    "button",
                    {
                      staticClass: "btn emergo-green-button side-btn",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("openRequest")
                        },
                      },
                    },
                    [_c("span", [_vm._v(_vm._s(_vm.button_name))])]
                  )
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _vm.design_type == "laptop"
        ? _c("div", { ref: "laptopContent", staticClass: "p-0 desc-content" }, [
            _c("div", {
              staticClass: "desc-subheader text-color-blue",
              domProps: { innerHTML: _vm._s(_vm.content.header) },
            }),
            _c("div", {
              domProps: { innerHTML: _vm._s(_vm.content.description) },
            }),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }